import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { IAndRsListComponent } from '@app/i-and-rs/list/components';
import { IAndRCreateDialog } from '@app/i-and-rs/list/dialogs';
import { IAndRStateStore } from '@app/i-and-rs/list/state/i-and-rs-list.store';
import { IAndR } from '@app/i-and-rs/list/types/i-and-rs';
import { IAndRListFilters } from '@app/i-and-rs/list/types/i-and-rs-filters';
import { ConfirmationService } from '@app/shared';
import { Pagination } from '@app/types/core';
import { UserModel } from '@app/users/models';
import { UIRouter } from '@uirouter/core';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-i-and-rs-list.view',
  templateUrl: './i-and-rs-list.view.html',
  styleUrls: ['./i-and-rs-list.view.scss'],
  providers: [IAndRStateStore]
})
export class IAndRListView implements OnInit {
  @Input() rolesFilter: string[] = [];
  @Input() usersFilter: UserModel[] = [];
  @Input() initializeSelected: boolean = false;
  @ViewChild(IAndRsListComponent, { static: true }) list: IAndRsListComponent;
  vm$ = this.store.vm$;

  constructor(
    private readonly dialog: MatDialog,
    private router: UIRouter,
    private readonly store: IAndRStateStore,
    private readonly confirmation: ConfirmationService
  ) { }

  ngOnInit(): void {
    const {
      current: { name: viewId }
    } = this.router.globals;

    this.store.init(viewId);

    if (this.initializeSelected) {
      this.onActiveOnlyChange(true)
      this.onSelectedChange(this.usersFilter, this.rolesFilter);
      this.onClearFilters({ page: 1, pageSize: 25 });
    };
  }

  showIAndRCreateDialog() {
    IAndRCreateDialog.open(this.dialog, {
      openDate: null
    }).afterClosed().pipe(
      filter(value => !!value)
    ).subscribe(iAndRCase => this.store.addIAndR(iAndRCase));
  }

  showDeleteDialog(iAndRs: IAndR) {
    const { number } = iAndRs;
    this.confirmation.confirm(`Delete I&R Case (${number})?`, 'DELETE', 'CANCEL').pipe(
      filter(ok => ok)
    ).subscribe(() => this.store.deleteIAndR(iAndRs.involvementId));
  }

  onFiltersChange(filters: IAndRListFilters, page: Pagination): void {
    const pageSize = page?.pageSize ?? 25;
    this.store.patchViewState({ filters, pagination: { page: 1, pageSize } });
  }

  onSelectedChange(users: UserModel[], roles: string[]) {
    this.store.patchViewState({ selected: { users, roles } });
  }

  onSearchChange(search: string) {
    this.store.patchViewState({ search });
  }

  onActiveOnlyChange(activeOnly: boolean) {
    this.store.patchViewState({ activeOnly });
  }

  onPageChange(pagination: Pagination) {
    this.store.patchViewState({ pagination });
  }

  onSortChange(sort: Sort) {
    this.store.patchViewState({ sort });
  }

  onToggleChange(value: boolean): void {
    this.store.patchState({ toggle: value });
  }

  onClearFilters(page: Pagination) {
    const filters: IAndRListFilters =
    {
      number: null,
      client: null,
      caseName: null,
      primaryStaff: null,
      legalTeam: null,
      funder: null,
      status: null,
      opened: null,
      closed: null
    }
    this.onFiltersChange(filters, page)
  }
}